<template>
  <div class="page" :class="{'page__has-bar': !readonly}">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.wo_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="creatorName">
            <label class="weui-form-preview__label">{{customLabel.creatorName || "申请人"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">{{form.main.creatorName}}
              <call-mobile :em-id="form.main.wo_emid"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="wo_department">
            <label class="weui-form-preview__label">{{customLabel.wo_department || "部门"}}</label>
            <span class="weui-form-preview__value">{{form.main.wo_department}}</span>
          </div>
          <div class="weui-form-preview__item" slot="wo_accountway">
            <label class="weui-form-preview__label">{{customLabel.wo_accountway || "核算方式"}}</label>
            <span class="weui-form-preview__value">{{form.main.wo_accountway}}</span>
          </div>
          <div class="weui-form-preview__item" slot="wo_startime">
            <label class="weui-form-preview__label">{{customLabel.wo_startime || "开始时间"}}</label>
            <span class="weui-form-preview__value">{{form.main.wo_startime}}</span>
          </div>
          <div class="weui-form-preview__item" slot="wo_endtime">
            <label class="weui-form-preview__label">{{customLabel.wo_endtime || "结束时间"}}</label>
            <span class="weui-form-preview__value">{{form.main.wo_endtime}}</span>
          </div>
          <div class="weui-form-preview__item" slot="wo_count">
            <label class="weui-form-preview__label">{{customLabel.wo_count || "加班时长"}}</label>
            <span class="weui-form-preview__value">{{form.main.wo_count}}</span>
          </div>
          <div class="weui-form-preview__item" slot="wo_remark">
            <label class="weui-form-preview__label">{{customLabel.wo_remark || "加班目的"}}</label>
            <span class="weui-form-preview__value">{{form.main.wo_remark}}</span>
          </div>
        </custom-layout>
      </div>
      <file-list v-model="form.main.wo_attach" />
      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.wd_detno }}</div>
          <div>
            <div class="weui-form-preview__item" slot="wd_emname">
              <label class="weui-form-preview__label">{{
                customLabel.wd_emname || "姓名"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.wd_emname
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="wd_emcode">
              <label class="weui-form-preview__label">{{
                customLabel.wd_emcode || "工号"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.wd_emcode
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/oa/overtime_edit?id='+form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
      >审核</a>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
      >删除</a>
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
      >反审</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import CallMobile from "@/components/button/CallMobile.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    FileList,
    CallMobile
  },
  data() {
    return {
      baseUrl: "/api/oa/workovertime",
      codeField: "wo_code",
      statusField: "wo_statuscode",
      caller: "WorkOverTime",
      xtype: "oa-workovertime-formpanel",
    };
  }
};
</script>